(function () {
  'use strict';

  var focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]'
  ].join(',');
  var savedTabindexAttribute = 'data-a11y-original-tabindex';
  var scheduledCarousels = [];
  var frameRequested = false;

  function getFocusableElements(slide) {
    var elements = Array.prototype.slice.call(slide.querySelectorAll(focusableSelector));

    if (slide.matches && slide.matches(focusableSelector)) {
      elements.unshift(slide);
    }

    return elements;
  }

  function setSlideFocusableState(slide, isHidden) {
    var ariaHidden = isHidden ? 'true' : 'false';

    if (slide.getAttribute('aria-hidden') !== ariaHidden) {
      slide.setAttribute('aria-hidden', ariaHidden);
    }

    if ('inert' in slide) {
      slide.inert = isHidden;
    }

    getFocusableElements(slide).forEach(function (element) {
      if (isHidden) {
        if (!element.hasAttribute(savedTabindexAttribute)) {
          element.setAttribute(
            savedTabindexAttribute,
            element.hasAttribute('tabindex') ? element.getAttribute('tabindex') : ''
          );
        }
        element.setAttribute('tabindex', '-1');
        return;
      }

      if (!element.hasAttribute(savedTabindexAttribute)) {
        return;
      }

      var originalTabindex = element.getAttribute(savedTabindexAttribute);
      if (originalTabindex === '') {
        element.removeAttribute('tabindex');
      } else {
        element.setAttribute('tabindex', originalTabindex);
      }
      element.removeAttribute(savedTabindexAttribute);
    });
  }

  function isSlideVisible(slide, viewportRect) {
    // Flickity exposes only its selected cell, even when a multi-card carousel
    // renders several cells at once. Use the clipped viewport instead so every
    // rendered card stays keyboard accessible while off-screen cards stay inert.
    var slideRect = slide.getBoundingClientRect();
    var horizontalOverlap = Math.min(slideRect.right, viewportRect.right) -
      Math.max(slideRect.left, viewportRect.left);
    var verticalOverlap = Math.min(slideRect.bottom, viewportRect.bottom) -
      Math.max(slideRect.top, viewportRect.top);

    return horizontalOverlap > 1 && verticalOverlap > 1;
  }

  function syncCarousel(carousel) {
    if (!carousel || !carousel.classList.contains('flickity-enabled')) {
      return;
    }

    var viewport = carousel.querySelector('.flickity-viewport');
    var slider = viewport && viewport.querySelector('.flickity-slider');

    if (!viewport || !slider) {
      return;
    }

    var viewportRect = viewport.getBoundingClientRect();
    if (viewportRect.width < 1 || viewportRect.height < 1) {
      return;
    }

    Array.prototype.forEach.call(slider.children, function (slide) {
      setSlideFocusableState(slide, !isSlideVisible(slide, viewportRect));
    });
  }

  function flushScheduledCarousels() {
    var carousels = scheduledCarousels.slice();

    scheduledCarousels = [];
    frameRequested = false;
    carousels.forEach(syncCarousel);
  }

  function scheduleCarousel(carousel) {
    if (!carousel || scheduledCarousels.indexOf(carousel) !== -1) {
      return;
    }

    scheduledCarousels.push(carousel);
    if (!frameRequested) {
      frameRequested = true;
      window.requestAnimationFrame(flushScheduledCarousels);
    }
  }

  function scheduleAllCarousels() {
    Array.prototype.forEach.call(document.querySelectorAll('.flickity-enabled'), scheduleCarousel);
  }

  function getCarousel(element) {
    return element && element.closest ? element.closest('.flickity-enabled') : null;
  }

  function init() {
    scheduleAllCarousels();

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        var carousel = getCarousel(mutation.target);

        if (carousel) {
          scheduleCarousel(carousel);
        }

        if (mutation.type === 'childList') {
          Array.prototype.forEach.call(mutation.addedNodes, function (node) {
            if (node.nodeType !== 1) {
              return;
            }

            if (node.classList.contains('flickity-enabled')) {
              scheduleCarousel(node);
            }

            Array.prototype.forEach.call(
              node.querySelectorAll ? node.querySelectorAll('.flickity-enabled') : [],
              scheduleCarousel
            );
          });
        }
      });
    }).observe(document.documentElement, {
      attributeFilter: ['aria-hidden', 'class', 'style'],
      attributes: true,
      childList: true,
      subtree: true
    });

    window.addEventListener('resize', scheduleAllCarousels);
    window.addEventListener('orientationchange', scheduleAllCarousels);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
